import type { SaleType } from '@thevillages/schemas';

export function ListingColor(saleType: SaleType, pending?: boolean, selected?: boolean): string {
  if (selected) {
    return '#ff0000';
  }

  if (pending) {
    return '#ecdcc2';
  }

  switch (saleType) {
    case 'homesite':
      return '#bc9b6a'; // --color-villages-gold-500
    case 'new':
      return '#00492b'; // --color-villages-green-500
    case 'preowned':
      return '#790307'; // --color-villages-red-500
    default:
      return 'gray';
  }
}
